/**
 * social share
 * get details from link attributes and construct popup
 **/
function SocialShare(){
    
    // On clicks of media icons
    $('.share-popup').click(function(){
        var sharelink = $(this).data('sharelink');
        var url = $(this).attr('data-url');
        window.open(sharelink,'_blank','height=400,width=600,menubar=0,resizable=1,toolbar=0,location=0',true);
    });
}

$(document).ready(function() {
	SocialShare();
});


// WEBPACK FOOTER //
// ./app/js/components/social-share.js